import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { t } from "i18next";
import React from "react";

const EventgalleryHeader = ({
  isEventModerator,
  parentEventTitle,
  breadCrumbText,
  addGalleryImageHandler,
}) => {
  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb
            breadCrumbText={breadCrumbText}
            displayName={parentEventTitle}
            top={false}
          />
        </div>

        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* --- action button section start ---- */}
          {/* <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-gray text-start w-100 dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Action
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm fw-semibold border-0 rounded-10 shadow-sm">
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2"
                  data-bs-toggle="modal"
                  data-bs-target="#addLabel"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">Add Label</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">Delete</span>
                </Link>
              </li>
            </ul>
          </div> */}
          {/* --- action button section end ---- */}

          {/* --- add new section start ---- */}
          {isEventModerator ? (
            <button
              onClick={addGalleryImageHandler}
              className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            >
              <span className="d-block">{t("Save")}</span>
              <span className="d-block material-symbols-outlined icon-md">
                save
              </span>
            </button>
          ) : null}
          {/* --- add new section end ---- */}
        </div>
      </div>
    </div>
  );
};

export default EventgalleryHeader;
